// extracted by mini-css-extract-plugin
export default {"button":"UploadButton_button__-+JNx","label":"UploadButton_label__OjCFY","buttonText":"UploadButton_buttonText__TUP3y"};